export default __webpack_public_path__ + "static/media/list.b12dfb5d.svg";